import Service from "../Service";

const resource = "HarvestSchedulePriceApproval/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },

    getByHvsID(hvsID, requestID) {
        return Service.get(resource + "getByHvsID", {
            params: { hvsID: hvsID, requestID: requestID },
        });
    },

    getPriceListByHvs(hvsID, requestID) {
        return Service.post("HarvestSchedule/priceListByHvs", {}, {
            params: { HvsID: hvsID, requestID: requestID },
        });
    },
};
